import { RoleDefinition } from 'src/state/agent-verification/types';

export const CURRENT_NONPROFIT_CUSTOMER_ROLE_KEY = 'current-nonprofit-customer';
export const PROSPECTIVE_NONPROFIT_CUSTOMER_ROLE_KEY = 'prospective-nonprofit-customer';
export const DEFAULT_PROSPECTIVE_TOPIC_KEY = 'default';

export const getAvailableSupportTicketRoleDefinitions = (
  roleDefinitions: RoleDefinition[],
  isAuthenticated: boolean
): RoleDefinition[] =>
  isAuthenticated
    ? roleDefinitions.filter((roleDefinition) => roleDefinition.key === CURRENT_NONPROFIT_CUSTOMER_ROLE_KEY)
    : roleDefinitions.filter((roleDefinition) => roleDefinition.key !== CURRENT_NONPROFIT_CUSTOMER_ROLE_KEY);

export const getSupportTicketRoleForAuthState = (role: string | undefined, isAuthenticated: boolean): string =>
  isAuthenticated
    ? CURRENT_NONPROFIT_CUSTOMER_ROLE_KEY
    : role === CURRENT_NONPROFIT_CUSTOMER_ROLE_KEY
    ? PROSPECTIVE_NONPROFIT_CUSTOMER_ROLE_KEY
    : role ?? '';

// When the resolved role is empty (e.g. an unauthenticated user with no
// agent-supplied role), default to the prospective nonprofit customer role and
// its registration topic so the ticket can still be submitted.
export const applyEmptyRoleTopicDefaults = (role: string, topic: string): { role: string; topic: string } =>
  role.trim()
    ? { role, topic }
    : { role: PROSPECTIVE_NONPROFIT_CUSTOMER_ROLE_KEY, topic: DEFAULT_PROSPECTIVE_TOPIC_KEY };

